import LazyLoad from 'vanilla-lazyload';

new LazyLoad({
    elements_selector: '[data-original], [data-original-set]'
});



/** WEBPACK FOOTER **
 ** ./assets/js/lib/lazyload.js
 **/